import { lazy } from 'react';

export const LazyThrowAFrontendErrorPleasePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--throw-a-frontend-error-please-page" */ './throw-a-frontend-error-please-page'
    ),
);
